import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { OnPageLoad } from 'src/app/services/on-page-load';
import { OnPageInit } from 'src/app/services/on-page-init';

@Component({
  template: '',
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export abstract class FacetsPage implements OnInit, OnPageLoad, OnPageInit {
  protected constructor(protected route: ActivatedRoute) {}

  ngOnInit() {
    this.OnPageInit();
    this.route.params.subscribe((p) => this.OnPageLoad(p));
  }

  abstract OnPageLoad(p: Params): void;

  OnPageInit(): void {}
}
